<template>
  <div id="CreateReport">
    <a-steps :current="current" labelPlacement="vertical">
      <a-step title="创建报告" />
      <a-step title="配置项目" />
      <a-step title="配置能力" />
    </a-steps>
    <div class="steps-content">
      <steps-first v-if="current === 0"></steps-first>
      <steps-second v-else-if="current === 1"></steps-second>
      <steps-third v-else-if="current === 2"></steps-third>
    </div>
  </div>
</template>

<script>
import stepsFirst from "./steps/StepsFirst.vue";
import stepsSecond from "./steps/StepsSecond.vue";
import StepsThird from "./steps/StepsThird.vue";

export default {
  name: "CreateReport",
  props: {
    reportId: "",
  },
  components: {
    stepsFirst,
    stepsSecond,
    StepsThird,
  },
  data() {
    return {
      current: 0,
    };
  },
};
</script>

<style lang="less" scoped>
#CreateReport {
  height: calc(100vh - 105px);
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }

  .steps-content {
    margin-top: 30px;
  }
}
</style>
